// Quote previews are derived, never stored: text bubbles show their text; attachments show a
// short type label (keeps parity with the backend and supports image/doc/etc. quotes).
export const QUOTE_TYPE_LABELS = {
  IMAGE: "Photo", VIDEO: "Video", AUDIO: "Audio", VOICE: "Voice message",
  DOCUMENT: "Document", FILE: "Document", STICKER: "Sticker",
  LOCATION: "Location", MAP: "Location", CONTACTS: "Contact", ORDER: "Order",
};

export const quotedPreviewOf = (msgObj, fallbackText) => {
  if (!msgObj) return fallbackText;
  const ct = String(msgObj.convoType || "").toUpperCase();
  if (ct && ct !== "TEXT" && ct !== "CUSTOM" && QUOTE_TYPE_LABELS[ct]) return QUOTE_TYPE_LABELS[ct];
  return msgObj?.message?.text || fallbackText;
};
